<main class="flex min-h-screen p-4 overflow-x-hidden public-page" role="main">
  <div class="m-auto mb-0 w-full max-w-[100%] md:max-w-[500px] flex flex-col min-h-0">
    <h1
      class="truncate pr-9 text-3xl max-w-full whitespace-nowrap overflow-hidden lg:text-5xl lg:leading-[120%]"
      id="loginFormHeading"
    >
      Login
    </h1>
    <form [formGroup]="loginForm" (ngSubmit)="onLogin()" role="form" aria-labelledby="loginFormHeading" class="flex-1">
      <app-card class="block w-full mt-6 mb-9">
        @if (loginError) {
          <p class="text-red-500 text-center mb-4" role="alert">
            {{ loginError }}
          </p>
        }
        <div class="custom-input-container mt-4 w-full">
          <label class="custom-label" for="usernameOrEmail">Gebruikersnaam / e-mailadres</label>
          <mat-form-field appearance="outline">
            <input
              id="usernameOrEmail"
              matInput
              type="text"
              formControlName="usernameOrEmail"
              placeholder="Jouw gebruikersnaam/e-mail"
              autocomplete="username"
              aria-describedby="usernameOrEmailError"
            />
            <mat-error id="usernameOrEmailError" role="alert">Vul een geldige gebruikersnaam of email in.</mat-error>
          </mat-form-field>
        </div>
        <div class="custom-input-container w-full custom-input-container--password">
          <label class="custom-label" for="password">Wachtwoord</label>
          <mat-form-field appearance="outline">
            <input
              id="password"
              matInput
              type="password"
              formControlName="password"
              placeholder="Jouw wachtwoord"
              autocomplete="current-password"
              aria-describedby="passwordError"
            />
            <app-password-toggle matSuffix [for]="'password'"></app-password-toggle>
            <mat-error id="passwordError" role="alert">Wachtwoord is te kort.</mat-error>
          </mat-form-field>
        </div>
        <div class="text-end text-base">
          <a routerLink="/reset-password">Wachtwoord vergeten? </a>
        </div>
      </app-card>
      <div class="flex justify-end mb-4">
        <button
          mat-flat-button
          color="accent"
          type="submit"
          [disabled]="loginForm.invalid || isLoading"
          class="w-full button-large"
        >
          Inloggen
        </button>
      </div>

      <div class="text-center sm:text-end text-base">
        Nog geen account? <a routerLink="/register" class="font-semibold text-primary-500">Registreren</a>
      </div>

      <div class="mt-4">
        <app-logo-images></app-logo-images>
      </div>
    </form>
  </div>
</main>
